import React from 'react'
import { Col, Row, Modal } from 'react-bootstrap'
import { QtyForm } from './QtyForm'
import { BillOfMaterial } from './BillOfMaterial'
import { Field, Form } from '@ztechapps/webui.form'
import { useFormikContext } from 'formik'
import { SaveCancelButtons } from '@ztechapps/webui.button'
import { useCreateAndBuildWorkOrder } from '@ztechapps/work-order.common'
import { useCreateAndBuildContext } from './Context'
import type { CreateAndBuildWorkOrderArgs } from '@ztechapps/common.contract'
import { Alert, HorizontalStack } from '@ztechapps/webui.util'
import { DelayedProductionButton } from './DelayedProductionButton'
export type FormFields = CreateAndBuildWorkOrderArgs

const FormDefaults: FormFields = {
  quantity: 0,
  bomItems: [],
  tags: null,
  remarks: null,
  product: null,
  relatedSalesOrders: [],
}

export const Layout = () => {
  const { remarks, product, productId, afterCreateAndBuild, qtyToBuild, relatedSalesOrders } =
    useCreateAndBuildContext()

  const billOfMaterials = product?.billOfMaterials
  const initialValues = React.useMemo<FormFields>(() => {
    return {
      ...FormDefaults,
      quantity: qtyToBuild,
      bomItems: billOfMaterials,

      remarks,
      product: { _id: productId },
      relatedSalesOrders,
    }
  }, [billOfMaterials, productId, remarks, qtyToBuild, relatedSalesOrders])

  const validate = (values: FormFields) => {
    const errors: any = {}
    if ((values?.quantity ?? 0) <= 0) {
      errors.quantity = 'Must be a value more than zero.'
    }

    return errors
  }

  const [onSubmit] = useCreateAndBuildWorkOrder()

  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={validate}
      afterSubmit={afterCreateAndBuild}
      afterReset={afterCreateAndBuild}
    >
      <>
        <Modal.Body>
          <Row>
            <Col md={3}>
              <div className="border-end pe-2">
                <QtyForm />
              </div>
            </Col>
            <Col md={9}>
              <Field
                name="bomItems"
                component={BillOfMaterial}
                onChange
                help="Choose which product to be included on work orders when you build this product"
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="gap-1">
          <Alert type="info" className="flex-fill p-0 m-0">
            <ul className="small my-0 py-2 ">
              <li>
                <b>Quick Production</b> – Instantly completes the production process, immediately consuming the selected
                products and updating inventory.
              </li>

              <li>
                <b>Delayed Production</b> – Generates a production order to be completed at a later time, with details
                available for review on the production screen.
              </li>
            </ul>
          </Alert>
          <div className="flex-fill">
            <SaveCancelChangesButton saveText="Create Quick Production" saveBusyText="Producing..." />
          </div>
        </Modal.Footer>
      </>
    </Form>
  )
}

export const SaveCancelChangesButton = (props) => {
  const { isSubmitting } = useFormikContext()
  const { canEdit } = useCreateAndBuildContext()

  return (
    <HorizontalStack gap={3} className="justify-content-between">
      <div>
        <DelayedProductionButton />
      </div>

      <div>
        <SaveCancelButtons disabled={!canEdit} isBusy={isSubmitting} saveType="submit" cancelType="reset" {...props} />
      </div>
    </HorizontalStack>
  )
}
